/**
 * Пять реакций, которые предлагаются первыми, — `QuickReaction` нативной Искры: ровно те,
 * что люди на самом деле ставят, в одно касание. Это подсказки, а не весь выбор: двойное
 * касание ставит любую эмодзи из настроек («Реакции»), а по умолчанию — сердце: «да, вот
 * это», и большой палец вверх был бы по ошибке холоднее.
 */
export const quickReactions = ['❤️', '👍', '😂', '😮', '😢'] as const;
export const defaultQuickReaction = '❤️';
